export default function CheckoutPage() {
  return (
    <div className="container-responsive py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Checkout</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-center text-gray-600">
          Checkout interface will be implemented in the next phase.
        </p>
      </div>
    </div>
  )
}